import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { User } from '../interfaces/user';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private readonly user$ = new ReplaySubject<User | undefined>();

  setUser(user: User): void {
    this.user$.next(user);
  }

  getUser$() {
    return this.user$.asObservable();
  }

  reset() {
    this.user$.next(undefined);
  }
}
